module.exports = __webpack_public_path__ + "static/media/video.4c2d521.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/video.mp4
// module id = Yub9
// module chunks = 0